import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { IProductData } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import Translate from 'components/Translate';
import FeeInstallments from './feeInstallment';
import FeeSubscription from './feeSubscription';
import { enPaymentType } from 'enums/enPaymentType';

interface IState extends IStateBase {
  cart: IProductData;
}

interface IProps {
  hiddenFeeInstallments?: boolean;
}

export default class Footer extends BaseComponent<IState, IProps>
{
  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
  }

  render() {

    if (!this.state) {
      return null;
    }

    const { cart } = this.state;

    return (
      <div className='chk-media-footer theme-footer'>
        {!this.props.hiddenFeeInstallments
          ? <FeeInstallments />
          : null
        }
        {cart.paymentType === enPaymentType.SUBSCRIPTION
          ? <FeeSubscription />
          : null
        }
        &nbsp;
        <span className='chk-footer-links'>
          <a
            className={'theme-footer'}
            href='https://eduzz.com/privacidade'
            target='_blank'
          >
            <Translate term='Política de privacidade' />
          </a>
          <a
            className={'theme-footer'}
            href='https://eduzz.com/termos'
            target='_blank'
          >
            <Translate term='Termos de compra' />
          </a>
          {cart.config.affiliateId !== 0
            ? <a
              className={'theme-footer'}
              target='_blank'
            >
              REF: {cart.config.affiliateId}
            </a>
            : null
          }
        </span>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Footer/index.tsx